import { useEffect, useRef } from 'react';

import { ChatDrawerScreen } from '@components/Web/Drawer/WebDrawerContext';
import { useCreateChatMutation } from '@graphql/generated';
import useActiveChat from '@hooks/useActiveChat';
import { useAppNavigation } from '@navigation/useAppNavigation';

export const useChatMentionPress = (navigateToChatOnMentionPress?: boolean) => {
  const { setActiveChat } = useActiveChat();
  const navigate = useAppNavigation();
  const navigateToChatOnMentionPressRef = useRef(navigateToChatOnMentionPress);
  navigateToChatOnMentionPressRef.current = navigateToChatOnMentionPress;

  const [createChat, { data: createChatData }] = useCreateChatMutation();

  useEffect(() => {
    if (!createChatData) return;
    const { createChat: chat } = createChatData;
    setActiveChat(chat);
    if (navigateToChatOnMentionPressRef.current) {
      navigate.navigateToChatDrawer({
        screen: ChatDrawerScreen.details,
        chatId: chat.id,
      });
    }
  }, [createChatData]);

  const onMentionPress = (userId: string) => {
    createChat({
      variables: { attributes: { userIds: [userId] } },
    });
  };

  return { onMentionPress };
};
